

class ReportScriptCell extends MUITableViewCell
{
    private nameLabel:MUILabel = null;
    awakeFromHTML(){
        this.nameLabel = MUIOutlet(this, "name-lbl", "MUILabel");
    }

    set item (file:ReportScriptItem) {
        this.nameLabel.text = file.name;
    }
}